import { motion } from "framer-motion";
import { Download, Lock } from "lucide-react";
import { AreaLayout } from "@/components/AreaLayout";

const MODULOS = [
  { n: "01", t: "Detente", obj: "Salir del piloto automático y hacer una pausa.", estado: "Muestra disponible", abierto: true },
  { n: "02", t: "Escucha", obj: "Reconocer qué sientes sin juzgarte.", estado: "Próximamente" },
  { n: "03", t: "Ordena", obj: "Separar el ruido de lo que de verdad importa.", estado: "Próximamente" },
  { n: "04", t: "Elige", obj: "Tomar una decisión que puedas sostener.", estado: "Próximamente" },
  { n: "05", t: "Da el paso", obj: "Convertir la decisión en una acción concreta.", estado: "Próximamente" },
  { n: "06", t: "Sostén", obj: "Mantener el avance cuando aparezcan las dudas.", estado: "Próximamente" },
];

export default function Academia() {
  return (
    <AreaLayout>
      <p className="eyebrow mb-4">Academia</p>
      <h1 className="font-display text-4xl text-[#102B5B] sm:text-5xl" style={{ fontWeight: 600 }} data-testid="academia-title">
        Da el Paso, paso a paso.
      </h1>

      {/* Lección muestra */}
      <div className="mt-10 rounded-3xl bg-[#102B5B] p-8 sm:p-10" data-testid="academia-muestra">
        <span className="eyebrow" style={{ color: "#C5D7F4" }}>Primera lección · muestra</span>
        <h2 className="font-display mt-3 text-2xl text-white sm:text-3xl" style={{ fontWeight: 600 }}>
          Detente: salir del piloto automático
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-[#E6EEFA]">
          Antes de cambiar nada, haz una pausa honesta. Observa tu día sin corregirlo: qué haces en
          automático, qué te pesa y qué te gustaría que fuera distinto.
        </p>
        <button
          type="button"
          disabled
          data-testid="academia-descargable"
          className="mt-6 inline-flex cursor-not-allowed items-center gap-2 rounded-full border border-[#C5D7F4] px-5 py-2.5 text-base font-semibold text-[#C5D7F4]"
        >
          <Download size={18} /> Hoja de observación · Próximamente
        </button>
      </div>

      {/* Módulos */}
      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {MODULOS.map((m, i) => (
          <motion.div
            key={m.n}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.35, delay: i * 0.06 }}
            className="soft-card p-6"
            data-testid={`academia-modulo-${i}`}
          >
            <div className="flex items-center justify-between">
              <span className="font-display text-2xl text-[#C5D7F4]" style={{ fontWeight: 600 }}>{m.n}</span>
              {m.abierto ? (
                <span className="rounded-full bg-[#E6EEFA] px-3 py-1 text-sm font-semibold text-[#1F4C98]">{m.estado}</span>
              ) : (
                <span className="inline-flex items-center gap-1.5 text-sm text-[#626B79]">
                  <Lock size={14} /> {m.estado}
                </span>
              )}
            </div>
            <h3 className="mt-3 text-xl font-semibold text-[#171A20]">{m.t}</h3>
            <p className="mt-2 text-base text-[#626B79]">{m.obj}</p>
          </motion.div>
        ))}
      </div>

      <p className="mt-8 text-base text-[#626B79]" data-testid="academia-empty">
        Tu siguiente práctica aparecerá aquí.
      </p>
    </AreaLayout>
  );
}
